import PubSub from "underpub-js";

var ListingPressReleases = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingPressReleases',
	};

	$.extend(true, this.options, options);

};

ListingPressReleases.prototype.init = function() {

	var self = this;

};

export default ListingPressReleases;
